import { Checkbox, Typography } from '@mui/material'
import { Box, styled } from '@mui/system'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import AssetsAccordion from './AssetsAccordion/AssetsAccordion'
import AssetsSearchList from './AssetsSearchList'
import { icons } from '../../../assets'
import { getMediaUrl } from '../../../helpers'
import { useDefaultComponentTools } from '../../../hooks/useDefaultComponentTools'
import {
	getAssetsData,
	setAssetSearch,
	setAssetSingle,
	setOnlyFavorite,
	updateDataSizeTradeLot
} from '../../../store/redusers/assets/actions'
import {
	selectAssetsCurrentList,
	selectAssetsFilter,
	selectSearchAssets,
	selectSearchAssetsSoIdesAll,
	selectOnlyFavorite, selectClassAssetsTypes, selectClassAssetsTypesDefault
} from '../../../store/redusers/assets/selectors'
import { selectAccessToken } from '../../../store/redusers/auth/selectors'
import {selectUserId} from '../../../store/redusers/user/selectors'
import AppSearch from '../../AppSearch'
import { AppSpin } from '../../AppSpin'


const AssetsBody = styled(Box)(() => ({
	height: '100%',
	overflow: 'auto'
}))

const AssetsHeader = styled(Box)(() => ({
	alignItems: 'center',
	display: 'flex',
	justifyContent: 'space-between'
}))

const AssetsList = styled(Box)(({theme, headerheight}) => ({
	borderRadius: '4px',
	marginTop: '16px',
	maxHeight: 'fit-content',
	overflow: 'auto',
	[theme.breakpoints.up('md')]: {
		maxHeight: `calc(100vh - ${(headerheight + 88 + 'px')})`
	}
}))

const AssetsControl = styled(Box)(() => ({
	alignItems: 'center',
	display: 'flex',
	height: '56px',
	justifyContent: 'space-between',
	padding: '0 16px'
}))

function Assets({headerHeight}) {
	const [isScrollBar, setIsScrollBar] = useState(false)
	const assetsFilter = useSelector(selectAssetsFilter)
	const { t, alert, dispatch, loading, setLoading, theme } = useDefaultComponentTools(true)
	const currentAsset = useSelector(selectAssetsCurrentList)
	const [refresh, setRefresh] = useState(false)
	const accessToken = useSelector(selectAccessToken)
	const isAuthorized = useSelector(selectUserId)
	const searchAssets = useSelector(selectSearchAssets) || []
	const [isSearchList, setIsSearchList] = useState(false)
	const assetsSoIdesAll = useSelector(selectSearchAssetsSoIdesAll)
	const onlyFavorite = useSelector(selectOnlyFavorite)
	const [localOnlyFavorite, setLocalOnlyFavorite] = useState(onlyFavorite)
	const [searchString, setSearchString] = useState('')
	const classAssetsTypes = useSelector(selectClassAssetsTypes)
	const classAssetsTypesDefault = useSelector(selectClassAssetsTypesDefault)

	useEffect(() => {
		if (currentAsset) setRefresh(true)
	}, [dispatch, assetsFilter, currentAsset])

	useEffect(() => {
		setLocalOnlyFavorite(onlyFavorite)
	}, [onlyFavorite])

	useEffect(() => {
		const getAssetsAll = async () => {
			try {
				setLoading(true)
				await dispatch(getAssetsData(isAuthorized ?
					classAssetsTypes :
					classAssetsTypesDefault, accessToken))
				setInterval(() => {
					// dispatch(getLotSizes())
					dispatch(updateDataSizeTradeLot())
				}, 60000)
			} catch (e) {
				alert.removeAll()
				alert.error(e.message)
			} finally {
				setLoading(false)
			}
			return true
		}
		getAssetsAll()
	}, [isAuthorized])

	useEffect(() => { dispatch(setAssetSearch(searchString)) }, [searchString])

	useEffect(() => {
		if (searchAssets.length && searchString) {
			setIsSearchList(true)
		}
		if (searchAssets.length < 1 || !searchString) {
			setIsSearchList(false)
			dispatch(setAssetSingle(null))
		}
	}, [dispatch, searchString, localOnlyFavorite])

	const handleOnlyFavorite = () => {
		dispatch(setOnlyFavorite(!localOnlyFavorite))
	}
	const mediaUrl = getMediaUrl()

	return (
		<AssetsBody>
			<AssetsHeader>
				<AppSearch placeholder={t('Search')+'...'} onUserInput={setSearchString} onRefresh={refresh}
					inputSx={{ width: '-webkit-fill-available' }} />
			</AssetsHeader>
			{isSearchList ? <AssetsSearchList setIsSearchList={setIsSearchList} searchAssets={searchAssets}/> : null}
			{loading
				? <AppSpin size={10} height={'400px'}/>
				: <AssetsList headerheight={headerHeight} sx={{border: theme.palette.border}}>
					<AssetsControl sx={{borderBottom: theme.palette.border, mr: isScrollBar ? '12px' : null}}>
						<Typography sx={{ width: '44%' }}>{t('Symbol')}</Typography>
						<Typography sx={{ textAlign: 'center', width: '22.5%' }}>{t('Bid')}</Typography>
						<Typography sx={{ textAlign: 'center', width: '22.5%' }}>{t('Ask')}</Typography>
						<Box sx={{ display: 'flex', justifyContent: 'center', width: '11%' }} >
							{accessToken ? <Checkbox
								checked={!!localOnlyFavorite}
								onClick={handleOnlyFavorite}
								icon={<img src={mediaUrl + icons.assetStarCheck} alt={'star-check'} />}
								checkedIcon={<img src={mediaUrl + icons.assetStarChecked} alt={'star'} />} /> : null}
						</Box>
					</AssetsControl>
					{!assetsSoIdesAll ?
						null :
						<AssetsAccordion setIsScrollBar={setIsScrollBar} assetsSoIdesAll={assetsSoIdesAll} />}
				</AssetsList>
			}
		</AssetsBody>
	)
}

Assets.propTypes = {
	headerHeight: PropTypes.number
}

export default Assets
